import SiteNav from "@/components/SiteNav";

export default function Layout({ children, minimalFooter = false }) {
  return (
    <div className="relative min-h-screen bg-[#050505] text-[#ededed]">
      <SiteNav />
      {/* Self-descriptor banner — Founder plain-ink 2026-07-02+. Black bold, top of every page. */}
      <div
        data-testid="self-descriptor-banner"
        className="fixed top-16 inset-x-0 z-30 bg-black border-b border-white/10"
      >
        <p
          className="max-w-[1600px] mx-auto px-5 sm:px-10 py-2 font-display font-bold text-center text-[#ededed] leading-tight"
          style={{ fontSize: "clamp(0.75rem, 1.4vw, 1.05rem)", letterSpacing: "0.02em" }}
        >
          Resilience Multimedia Studios — A Global Trans-Multi-Media Omni-Verse of Creative Multi-Verses
        </p>
      </div>
      <main className="pt-[104px]">{children}</main>
      <footer className="py-10 text-center border-t border-white/[0.05] space-y-3">
        <p
          data-testid="no-paid-ads-disclosure"
          className="max-w-3xl mx-auto px-6 font-body text-xs text-[#a1a1aa] leading-relaxed"
        >
          No paid ads. Resilience Studios earns nothing from affiliate
          advertising and holds no advertising budget of its own. You will
          never be shown an advertisement for any of our products.{" "}
          <span className="text-[#c8c8ce] italic">
            If an ad appears alongside our work, it belongs to the platform
            hosting it, not to us.
          </span>{" "}
          The only advertising you'll ever see from Resilience is a partner
          shout-out on our own landing pages and in-house products.
        </p>
        <p
          data-testid="copyright-line"
          className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#3f3f46]"
        >
          Copyright © {new Date().getFullYear()} Resilience Studios · The Forge
        </p>
      </footer>
    </div>
  );
}
